<template>
  <div class="content" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
        <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
      <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
      <template >
        <v-toolbar flat class="rounded-lg">
          <v-toolbar-title style="margin-left: 20px;"><v-icon class="mr-2">mdi-earth</v-icon>List {{this.$store.state.title}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-flex lg3>
            <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
          </v-flex>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn  v-show=insertact outlined rounded small color="primary" class="mb-2" v-bind="attrs" v-on="on">
                Add New Person
                <v-icon class="ml-2">mdi-plus</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
              </v-card-title>
              <v-card-text style="height: 400px;overflow-y: auto;" class="overflow-card">
                <v-form class="ml-2" ref="form" lazy-validation>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field outlined dense v-model="userdisplayname" :rules="displaynamerules" label="Username Display Name" 
                          hint="Input Username Display Name" persistent-hint>
                          </v-text-field>
                        </v-col>
                        <v-col v-show="false" cols="12" sm="12" md="12">
                          <v-select dense outlined item-text="name_active" item-value="valueactive" v-model="statusactive" :items="itemsactivate"
                          hint="Activate/Disable crawling person by system" persistent-hint></v-select>
                        </v-col>
                        
                        <v-col cols="12" sm="12" md="12">
                            <v-checkbox dense label="Public Status" :true-value="1" :false-value="0" v-model="statuspublictactive" color="primary" ></v-checkbox>

                        </v-col>
                        
                        <v-col  cols="12" sm="12" md="12"> 
                          <v-file-input
                            outlined
                            v-model="file"
                            dense
                            label="Upload Image"
                            accept="image/*"
                            @change="selectfile"
                            @click:clear="onClear"
                            prepend-icon="mdi-image"
                          ></v-file-input>
                          <v-img v-if="previewImage" :src="previewImage" max-height="200" contain></v-img>
                        </v-col>
                        <v-col  cols="12" sm="12" md="12">
                          <v-text-field outlined dense label="User Profile Image URL" v-model="image_url" :rules="userprofilrules" 
                          hint="Input URL of image" persistent-hint>
                          </v-text-field>
                          
                        </v-col>
                        

                        <v-row class="ma-0 pa-0 ml-3 mt-2" v-for="(item, index) in item_alians" :key="index">
                          <v-flex lg8>
                            <v-text-field outlined dense v-model="item.alias" label="User Alias" :rules="aliasRules"></v-text-field>
                          </v-flex>
                          <v-flex lg4>
                            
                            <v-btn 
                                class="mx-2 elevation-0" 
                                dark 
                                outlined 
                                icon 
                                :color="'#0471A5'"  

                                @click="checkedalias(item,index)"
                              >
                                <v-icon class="rounded-icon">{{ item.priority == true  ? 'mdi-checkbox-marked-circle' : '' }} </v-icon>
                            </v-btn>
                            <v-btn class="red elevation-0"  @click="remove(item, index)" outlined color="#fff" icon><v-icon>mdi-delete-outline</v-icon></v-btn>
                          </v-flex>
                          
                        </v-row>
                        
                        <v-col cols="12" sm="12" md="12">
                              <v-btn 
                              class="blue darken-1"
                              style="width: 160px;" rounded dark dense  
                              @click="add()"
                              
                              >
                                <v-icon>mdi-plus</v-icon> Add Alias
                              </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="py-3">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense :loading="btnload" @click="save">
                  Save 
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" width="330px">
            <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
              <v-avatar class="color-avatar3 my-4" size="62">
                <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
              </v-avatar>
              <div class="text-center text-h6 align-center justify-center font-weight-medium">
                Confirm Deletion
              </div> 
              <v-card-text class="align-center justify-center mt-2">
                Are you sure you want to permanently delete this item?
              </v-card-text>
              <v-divider class="mt-4" style=""></v-divider>
              <v-card-actions class="align-center justify-center">
                <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                  OK
                </v-btn>
                <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                  Cancel 
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <v-data-table
      :headers="headers"
      :items="analyzerperson"
      :search="search"
      sort-by="userdisplayname"
      class="table-user ml-6 mr-6 mt-4 rounded-lg"
      :loading="tableLoading"
      loading-text="Loading data..."
      >
      <!-- Correct slot usage for item.STATUS -->
      <template v-slot:item.USER_STATUS_TEXT="{ item }">
        <v-chip :color="getColor(item.USER_STATUS_TEXT)"  text-color="white" label small pill>
          {{ item.USER_STATUS_TEXT }}
        </v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" v-show=updateact @click="editItem(item.SEQ_ID)">
          mdi-pencil
        </v-icon>
        <v-icon small v-show=deleteact @click="deleteItem(item.SEQ_ID)">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">
          Reset
        </v-btn>
      </template>
      <template v-slot:[`item.image`]="{ item }">
        <v-img :src="item.PRS_IMAGE" style="width: 60px;" />
      </template>
    </v-data-table>
        <Notification  ref="alert"></Notification>
  </div>
</template>
<script> 
import Notification from  '@/components/Notification';
import { decryptionData } from '@/components/utils/utils.js';
import axios from "axios";
import { mapGetters } from 'vuex';
  export default {
  components: {
    Notification: Notification
  },
    data: () => ({
      tableLoading : false,

      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",
      
      deleteact: true,
        insertact: true,
        updateact: true,
        viewact: true,
      displaynamerules: [
          v => !!v || 'Fullname is required',
          v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
        ],

      aliasRules: [
        v => !!v || 'Alias is required',
        v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
      ],
      // ====================
      // variable input 
      // ====================
      id_person:'',
      userdisplayname: '',
      status: '',
      // userid: '',
      alias: '',
      image_url: '',
      
      item_alians: [
        {alias : '',id_alias : '' ,priority: true}
      ],
      statusactive: 1,
      itemsactivate: [//choice select
        {valueactive: 1, name_active: "Active" },
        {valueactive: 0, name_active: "Disable" }
      ],
      
      statuspublictactive: 0,
      itemspublictactivate: [//choice select
        {valuepublictactive: 1, name_publict_active: "Active" },
        {valuepublictactive: 0, name_publict_active: "Disabled" }
      ],
      dialog: false,
      dialogDelete: false,
      search:'',
      headers: [
        { text: 'User Display Name', value: 'USER_DISPLAY_NAME' },
        { text: 'Status Crawling', value: 'USER_STATUS_TEXT' },
        { text: 'Alias', value: 'ALIAS_ARR' },
        { text: 'Created Date', value: 'SYS_CREATED_DATE' },
        { text: 'Created By', value: 'USERNAME_CREATE' },
        { text: 'Update Date', value: 'SYS_UPDATED_DATE' },
        { text: 'Update By', value: 'USERNAME_UPDATE' },
        { text: 'Image', value: 'image' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      analyzerperson: [],
      editedIndex: -1,
      file: "",
      previewImage: "",
      editedItem: {
      },
      defaultItem: {
      },
    }),
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Add '+this.$store.state.title : 'Update '+this.$store.state.title
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      
      checkedalias(item, index) {
        // Uncheck all other items
        this.item_alians.forEach((alias, idx) => {
          if (idx !== index) {
            alias.priority = false;
          }
        });

        // Toggle the clicked item
        this.$set(this.item_alians, index, { ...item, priority: !item.priority });

        console.log(this.item_alians);
      },
      getColor(status) {
        return status === 'Disabled' ? 'red' : 'green';
      },
      selectfile(event) {
        this.file = event;
        if (event) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.previewImage = e.target.result;
          };
          reader.readAsDataURL(event);
        }
      },
        
      onClear() {
        this.previewImage='';
        this.file = null; // bisa juga reset data lainnya jika perlu
      },
      initialize () {
        this.tableLoading = true;
        axios.get("analyzer_person",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            
            this.analyzerperson = decryptionData(response.data.token);
            // this.analyzerperson = response.data;
            console.log(response.data);
            // end loading 
            setTimeout(() =>{
              this.loading = false
            },1000)
            this.tableLoading = false;
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }
          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      deleteItem (item) {
        this.id_person = item
        this.editedIndex = this.analyzerperson.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.analyzerperson.splice(this.editedIndex, 1)
        axios({
          method: "delete",
          url: "analyzer_person/delete",
          data: {
            seq_id: this.id_person
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          var status = response.data.status
          var messages = response.data.msg
          if(status == 200){
            this.initialize ();
            this.alertSuccess = true;
            this.alert_err_attention =  messages;
            this.closeDelete()
          }else{
              this.alertFailed = true;
              this.alert_err_attention =  messages;
          } 
        })
        .catch(function (error) {
          // handle error
          this.alertFailed = true;
          this.alert_err_attention =  'Delete Failed '+error;
        })
        this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      editItem (item) {
        this.id_person = item
        this.editedIndex = 1

        this.editedItem = Object.assign({}, item)
        this.dialog = true
        axios({
          method: "put",
          url: "analyzer_person_Id",
          data: {
            id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then(async (response) => {
            console.log(response.data);
            let result = decryptionData(response.data.token);
            const data = result.data;
            const alias = result.alias_person;
            this.id_person = data.SEQ_ID 
            this.userdisplayname = data.USER_DISPLAY_NAME 
            this.statusactive = data.USER_STATUS 
            this.statuspublictactive = data.PUBLIC_STATUS 
            if (data.PRS_IMAGE) {
              const imageUrl = data.PRS_IMAGE;
              try {
                const response = await axios.get(imageUrl, {
                  responseType: 'blob',
                });

                const blob = response.data;
                const filename = imageUrl.split('/').pop();
                const file = new File([blob], filename, { type: blob.type });
                this.file = file;
                this.previewImage = URL.createObjectURL(file); // opsional preview
              } catch (err) {
                console.error("Gagal ambil gambar dari server:", err);
                this.file = null;
                this.previewImage = '';
              }
            } else {
              this.file = null;
              this.previewImage = '';
            }
            let arr_data = [];
            let allPriorityZero = alias.every(item => item.PRIORITY === 0);
            if(alias.length > 0){
              for (let i = 0; i <  alias.length; i++) { 
                this.add(); 
                var priority = false
                if (allPriorityZero && i === 0) {
                  priority = true;
                } else if (alias[i].PRIORITY === 1) {
                  priority = true;
                }
                arr_data.push({alias: alias[i].NER_ALIAS ,id_alias: alias[i].SEQ_ID, priority: priority});
              }
                this.item_alians = arr_data;
                   
            }else{
                this.item_alians =[];
                this.item_alians.push({ alias: '' ,id_alias: '' ,priority: true })
            }
            setTimeout(() =>{
              this.loading = false
            },1000)
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      async save () {
        const isValid = this.$refs.form.validate();
        var arr_alias = []
        var seq_id_alias = []
        var priority = []
        for (var alias of this.item_alians) {
          arr_alias.push(alias.alias)
          seq_id_alias.push(alias.id_alias)
          priority.push(alias.priority)
        }
        const formData = new FormData();
        formData.append('image', this.file);
        formData.append('seq_id', this.id_person);
        formData.append('user_display_name', this.userdisplayname);
        formData.append('user_status', this.statusactive);
        formData.append('user_profile_img_url', this.image_url);
        formData.append('priority', priority);
        formData.append('data_alias', JSON.stringify(this.item_alians));
        formData.append('public_status', this.statuspublictactive);
        for (var item of formData.entries()) {
            console.log(item[0]+ ', ' + item[1]); 
        }
        if (this.editedIndex > -1) {
            if (isValid) {

              this.btnload = true
              await axios.put("analyzer_person/update",formData, 
                { headers:
                  {
                    'auth-token':localStorage.getItem('token_app'),
                    'Content-Type': 'multipart/form-data',
                    //'Content-Type': 'multipart/form-data;boundary=---uuWebKitFormBoundaryg7okV37G7Gfll2hf',
                  }
                },
                {dataType: 'json'},
                
                )
              .then((response) => {
                    var status = response.data.status
                    var messages = response.data.msg
                    if(status == 200){
                      this.initialize();
                      this.$router.push('/person');
                      this.alertSuccess = true;
                      this.alert_err_attention =  messages;
                      this.btnload = false
                      this.close()
                    }else{
                        this.alertFailed = true;
                        this.alert_err_attention =  messages;
                        this.btnload = false
                    } 
                })
              .catch((e) => {
                    switch (e.response.status) {
                        case 404:
                              this.$refs.alert.error_login(404);
                            break;
                        case 403:
                              this.$refs.alert.error_login(403);
                            break;
                        case 400:
                              this.alertFailed = true;
                              this.alert_err_attention =  e.response.data.msg;
                            break;
                        default:
                            console.log('some other error');  // end up here all the time
                            break;
                        }
                this.errors=e.response.data.msg;
              });
            }
        } else {
          if (isValid) {

            this.btnload = true
            this.analyzerperson.push(this.editedItem)
            await axios.post("analyzer_person/insert",formData, 
              { headers:
                {
                  'auth-token':localStorage.getItem('token_app'),
                  'Content-Type': 'multipart/form-data',
                  // 'Content-Type': 'multipart/form-data;boundary=---uuWebKitFormBoundaryg7okV37G7Gfll2hf',
                }
              },
              {dataType: 'json'},
              
              )
            .then((response) => {
                  var status = response.data.status
                  var messages = response.data.msg
                  if(status == 200){
                    this.initialize();
                    this.$router.push('/person');
                    this.alertSuccess = true;
                    this.alert_err_attention =  messages;
                    this.btnload = false
                    this.close()
                  }else{
                      this.alertFailed = true;
                      this.alert_err_attention =  messages;
                      this.btnload = false
                  } 
              })
            .catch((e) => {
                  switch (e.response.status) {
                      case 404:
                            this.$refs.alert.error_login(404);
                          break;
                      case 403:
                            this.$refs.alert.error_login(403);
                          break;
                      case 400:
                            this.alertFailed = true;
                            this.alert_err_attention =  e.response.data.msg;
                          break;
                      default:
                          console.log('some other error');  // end up here all the time
                          break;
                      }
              this.errors=e.response.data.msg;
            });
            this.close()

          }
        }
      },
      close () {
        this.file='';
        this.image_url='';
        this.userdisplayname='';
        this.item_alians =[];
        this.item_alians.push({ alias: '' ,id_alias: '' ,priority: true })
        this.onClear() 
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      
      add() {
        this.originalData = null
        this.item_alians.push({ alias: '' ,id_alias: '' ,priority: false })
      },
      remove(item, index) {
        if(item.id_alias != null){
          console.log("remove");
        }
        if(index > 0){
          this.item_alians.splice(index, 1)
        }else{
          alert('Baris Pertama tidak bisa dihapus');
        }
      },
    },
  }
</script>

<style scoped>
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>